<template>
  <!-- eslint-disable -->
  <div>
    <div class="column-left">
      <SideNav />
    </div>
    <Loader v-if="!loaded" />

    <div v-if="loaded" class="column-right">
      <TopNav />
      <div class="main-container">

        <!-- Page Header -->
        <div class="page-header">
          <div class="header-content">
            <div class="title-section">
              <div class="page-icon" :style="{
                backgroundImage: `linear-gradient(139deg, ${prestador.admin.assets.colors.primary} 0%, ${prestador.admin.assets.colors.secondary} 100%)`
              }">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                  <circle cx="8" cy="16" r="2"></circle>
                  <path d="M10.3 17.7l1.4 1.4"></path>
                  <path d="M12.7 15.3l1.4 1.4"></path>
                </svg>
              </div>
              <div>
                <h1 class="page-title">Configuración Horaria por Categoría</h1>
                <p class="page-subtitle">Gestión de duraciones y restricciones de tiempo por especialidad médica</p>
              </div>
            </div>

            <div class="header-actions">
              <button class="primary-action-btn" @click="crearNuevo"
                :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
                Nueva Configuración
              </button>
            </div>
          </div>
        </div>

        <!-- Error Alert -->
        <div v-if="error" class="error-alert">
          <div class="alert-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
          </div>
          <span>{{ error }}</span>
        </div>

        <!-- Configuration Cards -->
        <div class="configurations-container">
          <!-- New Configuration Card -->
          <div v-if="editando_id === 'nuevo'" class="config-card new-config-card">
            <div class="card-header">
              <div class="card-icon new-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="8" x2="12" y2="16"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                </svg>
              </div>
              <div class="card-title-section">
                <h3 class="card-title">Nueva Configuración</h3>
                <p class="card-subtitle">Crear configuración horaria para una categoría</p>
              </div>
            </div>

            <div class="card-content">
              <div class="form-grid">
                <!-- Category Selection -->
                <div class="form-field full-width">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                    </svg>
                    Categoría Médica
                  </label>
                  <select v-model="form.categoria_id" class="medical-select" required>
                    <option :value="null" disabled>Selecciona una especialidad</option>
                    <option v-for="cat in categorias" :key="cat.id" :value="cat.id">
                      {{ cat.nombre }}
                    </option>
                  </select>
                </div>

                <!-- Duration Fields -->
                <!-- <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12,6 12,12 8,14"></polyline>
                    </svg>
                    Duración Mínima (min)
                  </label>
                  <input type="number" v-model.number="form.duracion_minima" class="medical-input" min="1"
                    placeholder="15" required />
                </div>

                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12,6 12,12 16,14"></polyline>
                    </svg>
                    Duración Máxima (min)
                  </label>
                  <input type="number" v-model.number="form.duracion_maxima" class="medical-input" min="1"
                    placeholder="120" required />
                </div> -->

                <div class="form-field">
                  <label class="field-label">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12,6 12,12 14,14"></polyline>
                    </svg>
                    Duración Por Defecto (min)
                  </label>
                  <input type="number" v-model.number="form.duracion_default" class="medical-input" min="1"
                    placeholder="30" required />
                </div>

                <!-- Checkbox Field -->
                <div class="form-field full-width">
                  <div class="checkbox-container">
                    <label class="checkbox-label">
                      <input type="checkbox" v-model="form.bloquear_horas_fuera_rango" class="medical-checkbox" />
                      <div class="checkbox-custom" :style="{ 'border-color': prestador.admin.assets.colors.primary }">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="3">
                          <polyline points="20,6 9,17 4,12"></polyline>
                        </svg>
                      </div>
                      <span class="checkbox-text">Bloquear citas fuera del rango de duración</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-actions">
              <button class="save-btn" @click="guardarConfiguracion"
                :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="20,6 9,17 4,12"></polyline>
                </svg>
                Guardar Configuración
              </button>
              <button class="cancel-btn" @click="cancelarEdicion">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <line x1="18" y1="6" x2="6" y2="18"></line>
                  <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                Cancelar
              </button>
            </div>
          </div>

          <!-- Existing Configuration Cards -->
          <div v-for="config in configuraciones" :key="config.id" class="config-card">
            <!-- View Mode -->
            <div v-if="editando_id !== config.id" class="card-view-mode">
              <div class="card-header">
                <div class="card-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                  </svg>
                </div>
                <div class="card-title-section">
                  <h3 class="card-title">{{ getNombreCategoria(config.categoria_id) }}</h3>
                  <p class="card-subtitle">Configuración de horarios médicos</p>
                </div>
                <div class="card-status">
                  <span class="status-badge"
                    :class="config.bloquear_horas_fuera_rango ? 'status-restricted' : 'status-flexible'">
                    {{ config.bloquear_horas_fuera_rango ? 'Restringido' : 'Flexible' }}
                  </span>
                </div>
              </div>

              <div class="card-content">
                <div class="info-grid">
                  <!-- <div class="info-item">
                    <div class="info-icon min-duration">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 8,14"></polyline>
                      </svg>
                    </div>
                    <div class="info-content">
                      <span class="info-label">Duración Mínima</span>
                      <span class="info-value">{{ config.duracion_minima }} min</span>
                    </div>
                  </div> -->

                  <!-- <div class="info-item">
                    <div class="info-icon max-duration">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 16,14"></polyline>
                      </svg>
                    </div>
                    <div class="info-content">
                      <span class="info-label">Duración Máxima</span>
                      <span class="info-value">{{ config.duracion_maxima }} min</span>
                    </div>
                  </div> -->

                  <div class="info-item">
                    <div class="info-icon default-duration">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 14,14"></polyline>
                      </svg>
                    </div>
                    <div class="info-content">
                      <span class="info-label">Duración Por Defecto</span>
                      <span class="info-value">{{ config.duracion_default }} min</span>
                    </div>
                  </div>

                  <div class="info-item">
                    <div class="info-icon restriction">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <circle cx="12" cy="16" r="1"></circle>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </svg>
                    </div>
                    <div class="info-content">
                      <span class="info-label">Restricción de Rango</span>
                      <span class="info-value">{{ config.bloquear_horas_fuera_rango ? 'Activada' : 'Desactivada'
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-actions">
                <button class="edit-btn" @click="toggleEditar(config)"
                  :style="{ 'color': prestador.admin.assets.colors.primary, 'border-color': prestador.admin.assets.colors.primary }">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                  Editar
                </button>
                <button class="delete-btn" @click="confirmarEliminacion(config)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="3,6 5,6 21,6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                  Eliminar
                </button>
              </div>
            </div>

            <!-- Edit Mode -->
            <div v-else class="card-edit-mode">
              <div class="card-header">
                <div class="card-icon edit-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </div>
                <div class="card-title-section">
                  <h3 class="card-title">Editando Configuración</h3>
                  <p class="card-subtitle">Modificar parámetros de horarios</p>
                </div>
              </div>

              <div class="card-content">
                <div class="form-grid">
                  <!-- Category Selection -->
                  <div class="form-field full-width">
                    <label class="field-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
                      </svg>
                      Categoría Médica
                    </label>
                    <select v-model="form.categoria_id" class="medical-select" required>
                      <option :value="null" disabled>Selecciona una especialidad</option>
                      <option v-for="cat in categorias" :key="cat.id" :value="cat.id">
                        {{ cat.nombre }}
                      </option>
                    </select>
                  </div>

                  <!-- Duration Fields -->
                  <!-- <div class="form-field">
                    <label class="field-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 8,14"></polyline>
                      </svg>
                      Duración Mínima (min)
                    </label>
                    <input type="number" v-model.number="form.duracion_minima" class="medical-input" min="1" required />
                  </div>

                  <div class="form-field">
                    <label class="field-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 16,14"></polyline>
                      </svg>
                      Duración Máxima (min)
                    </label>
                    <input type="number" v-model.number="form.duracion_maxima" class="medical-input" min="1" required />
                  </div> -->

                  <div class="form-field">
                    <label class="field-label">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <polyline points="12,6 12,12 14,14"></polyline>
                      </svg>
                      Duración Por Defecto (min)
                    </label>
                    <input type="number" v-model.number="form.duracion_default" class="medical-input" min="1"
                      required />
                  </div>

                  <!-- Checkbox Field -->
                  <div class="form-field full-width">
                    <div class="checkbox-container">
                      <label class="checkbox-label">
                        <input type="checkbox" v-model="form.bloquear_horas_fuera_rango" class="medical-checkbox" />
                        <div class="checkbox-custom" :style="{ 'border-color': prestador.admin.assets.colors.primary }">
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="3">
                            <polyline points="20,6 9,17 4,12"></polyline>
                          </svg>
                        </div>
                        <span class="checkbox-text">Bloquear citas fuera del rango de duración</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-actions">
                <button class="save-btn" @click="guardarConfiguracion"
                  :style="{ 'background-color': prestador.admin.assets.colors.primary }">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="20,6 9,17 4,12"></polyline>
                  </svg>
                  Guardar Cambios
                </button>
                <button class="cancel-btn" @click="cancelarEdicion">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import Loader from '@/components/Loader.vue';
import TopNav from '@/components/TopNav.vue';

export default {
  name: 'ConfiguracionHorariaCategoria',
  components: { TopNav, SideNav, Loader },
  data() {
    return {
      loaded: false,
      configuraciones: [],
      editando_id: null,
      error: null,
      form: {
        id: null,
        categoria_id: null,
        duracion_minima: 60,
        duracion_maxima: 600,
        duracion_default: 60,
        bloquear_horas_fuera_rango: true
      }
    };
  },
  computed: {
    ...mapGetters(['categorias', 'prestador'])
  },
  async created() {
    await this.cargarConfiguraciones();
  },
  methods: {
    getNombreCategoria(categoria_id) {
      const categoria = this.categorias.find(c => c.id === categoria_id);
      return categoria ? categoria.nombre : 'Desconocida';
    },

    async cargarConfiguraciones() {
      this.loaded = false;
      this.error = null;
      try {
        const response = await axios.get(`${window.hostname}/api/admin/configuracion_horaria`);
        if (response.data && response.data.configuraciones) {
          this.configuraciones = response.data.configuraciones;
        }
      } catch (error) {
        this.error = this.obtenerMensajeError(error);
        console.error('Error cargando configuraciones:', error);
      } finally {
        this.loaded = true;
      }
    },

    crearNuevo() {
      this.editando_id = 'nuevo';
      this.form = {
        id: null,
        categoria_id: null,
        duracion_minima: 59,
        duracion_maxima: 120,
        duracion_default: 60,
        bloquear_horas_fuera_rango: true
      };
    },

    toggleEditar(config) {
      this.editando_id = config.id;
      this.form = { ...config };
    },

    cancelarEdicion() {
      this.editando_id = null;
      this.error = null;
    },

    validarFormulario() {
      // if (!this.form.categoria_id) {
      //   this.error = 'Debe seleccionar una categoría';
      //   return false;
      // }
      // if (!this.form.duracion_minima || this.form.duracion_minima <= 0) {
      //   this.error = 'Duración mínima debe ser mayor a 0';
      //   return false;
      // }
      // if (!this.form.duracion_maxima || this.form.duracion_maxima <= 0) {
      //   this.error = 'Duración máxima debe ser mayor a 0';
      //   return false;
      // }
      // if (this.form.duracion_minima >= this.form.duracion_maxima) {
      //   this.error = 'Duración mínima debe ser menor que la máxima';
      //   return false;
      // }
      // if (!this.form.duracion_default ||
      //   this.form.duracion_default < this.form.duracion_minima ||
      //   this.form.duracion_default > this.form.duracion_maxima) {
      //   this.error = 'Duración default debe estar entre mínima y máxima';
      //   return false;
      // }
      return true;
    },

    async guardarConfiguracion() {
      if (!this.validarFormulario()) return;

      try {
        const url = `${window.hostname}/api/admin/configuracion_horaria`;
        const response = await axios.post(url, this.form);

          this.$bvToast.toast(response.data.message, {
            title: 'Éxito',
            variant: 'success',
            solid: true
          });

          await this.cargarConfiguraciones();
          this.cancelarEdicion();
      } catch (error) {
        this.error = this.obtenerMensajeError(error);
        console.error('Error guardando configuración:', error);
      }
    },

    confirmarEliminacion(config) {
      if (confirm(`¿Eliminar configuración para ${this.getNombreCategoria(config.categoria_id)}?`)) {
        this.eliminarConfiguracion(config.id);
      }
    },

    async eliminarConfiguracion(id) {
      try {
        const response = await axios.delete(`${window.hostname}/api/admin/configuracion_horaria/${id}`);

        if (response.data && response.data.message) {
          this.$bvToast.toast('Configuración eliminada correctamente', {
            title: 'Éxito',
            variant: 'success',
            solid: true
          });

          await this.cargarConfiguraciones();
          if (this.editando_id === id) {
            this.cancelarEdicion();
          }
        }
      } catch (error) {
        this.error = this.obtenerMensajeError(error);
        console.error('Error eliminando configuración:', error);
      }
    },

    obtenerMensajeError(error) {
      if (error.response) {
        return error.response.data.error ||
          error.response.data.message ||
          `Error: ${error.response.status} ${error.response.statusText}`;
      }
      return error.message || 'Error desconocido';
    }
  }
};
</script>

<style scoped>
/* Base Styles - Notion-inspired with medical touches */
.column-right {
  background-color: var(--background-primary);
  padding-top: 0px;
  padding-left: 275px;
  width: 100%;
  min-height: 100vh;
}

.main-container {
  background: white;
  border-radius: 16px;
  margin: 2rem;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;

}

.medical-schedule-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  padding: 2rem;
  margin-left: 280px;
}

/* Page Header */
.page-header {
  background: white;
  border-radius: 16px;
  padding: 2vh;
  margin-bottom: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid #e2e8f0;

}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.title-section {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.page-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 0.5rem;
  letter-spacing: -0.025em;
}

.page-subtitle {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0;
  font-weight: 400;
}

.header-actions {
  display: flex;
  align-items: center;
}

.primary-action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.primary-action-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
}

/* Error Alert */
.error-alert {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;
  color: #991b1b;
  font-weight: 500;
}

.alert-icon {
  color: #ef4444;
  flex-shrink: 0;
}

/* Configurations Container */
.configurations-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
  gap: 2rem;
}

/* Configuration Cards */
.config-card {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.config-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07), 0 1px 3px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.new-config-card {
  border-color: #10b981;
  background: linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%);
}

.new-config-card:hover {
  border-color: #059669;
}

/* Card Header */
.card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.new-config-card .card-header {
  background: #f0fdf4;
  border-bottom-color: #d1fae5;
}

.card-icon {
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);
}

.new-icon {
  background: linear-gradient(135deg, #10b981, #059669);
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.2);
}

.edit-icon {
  background: linear-gradient(135deg, #f59e0b, #d97706);
  box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);
}

.card-title-section {
  flex: 1;
}

.card-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 0.25rem;
}

.card-subtitle {
  font-size: 0.875rem;
  color: #64748b;
  margin: 0;
}

.card-status {
  display: flex;
  align-items: center;
}

.status-badge {
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.status-restricted {
  background: #fef2f2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

.status-flexible {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

/* Card Content */
.card-content {
  padding: 1.5rem;
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-field.full-width {
  grid-column: 1 / -1;
}

.field-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
}

.field-label svg {
  color: #64748b;
}

/* Form Elements */
.medical-input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.medical-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.medical-select {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  background: white;
  transition: all 0.2s ease;
}

.medical-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Checkbox */
.checkbox-container {
  display: flex;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  font-size: 0.875rem;
  color: #374151;
}

.medical-checkbox {
  display: none;
}

.checkbox-custom {
  width: 20px;
  height: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: white;
}

.medical-checkbox:checked+.checkbox-custom {
  background-color: currentColor;
  border-color: currentColor;
}

.medical-checkbox:checked+.checkbox-custom svg {
  color: white;
}

.checkbox-custom svg {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.medical-checkbox:checked+.checkbox-custom svg {
  opacity: 1;
}

.checkbox-text {
  font-weight: 500;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}

.info-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.min-duration {
  background: linear-gradient(135deg, #10b981, #059669);
}

.max-duration {
  background: linear-gradient(135deg, #ef4444, #dc2626);
}

.default-duration {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
}

.restriction {
  background: linear-gradient(135deg, #f59e0b, #d97706);
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.info-label {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.info-value {
  font-size: 1rem;
  font-weight: 600;
  color: #1e293b;
}

/* Card Actions */
.card-actions {
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.new-config-card .card-actions {
  background: #f0fdf4;
  border-top-color: #d1fae5;
}

.save-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #10b981;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  justify-content: center;
}

.save-btn:hover {
  background: #059669;
  transform: translateY(-1px);
}

.cancel-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  color: #64748b;
  border: 2px solid #e2e8f0;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  justify-content: center;
}

.cancel-btn:hover {
  border-color: #cbd5e1;
  background-color: #f8fafc;
}

.edit-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  border: 2px solid #e2e8f0;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  justify-content: center;
}

.edit-btn:hover {
  background-color: rgba(59, 130, 246, 0.05);
  transform: translateY(-1px);
}

.delete-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  color: #ef4444;
  border: 2px solid #fecaca;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1;
  justify-content: center;
}

.delete-btn:hover {
  background-color: #fef2f2;
  border-color: #f87171;
  transform: translateY(-1px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .medical-schedule-container {
    margin-left: 0;
    padding: 1rem;
  }

  .configurations-container {
    grid-template-columns: 1fr;
  }

  .header-content {
    flex-direction: column;
    align-items: stretch;
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .medical-schedule-container {
    padding: 0.5rem;
  }

  .page-header {
    padding: 1.5rem;
  }

  .title-section {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }

  .page-icon {
    width: 48px;
    height: 48px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .card-actions {
    flex-direction: column;
  }

  .card-header {
    flex-direction: column;
    text-align: center;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .medical-schedule-container {
    padding: 0.25rem;
  }

  .page-header {
    padding: 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .card-actions {
    padding: 1rem;
  }

  .info-item {
    padding: 0.75rem;
  }
}

/* Focus States */
.medical-input:focus,
.medical-select:focus,
.save-btn:focus,
.cancel-btn:focus,
.edit-btn:focus,
.delete-btn:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* High Contrast Mode */
@media (prefers-contrast: high) {
  .config-card {
    border-width: 2px;
  }

  .medical-input,
  .medical-select {
    border-width: 2px;
  }

  .save-btn,
  .cancel-btn,
  .edit-btn,
  .delete-btn {
    border-width: 2px;
  }
}

/* Reduced Motion */
@media (prefers-reduced-motion: reduce) {

  .config-card,
  .medical-input,
  .medical-select,
  .save-btn,
  .cancel-btn,
  .edit-btn,
  .delete-btn,
  .checkbox-custom {
    transition: none;
  }
}

@media (max-width: 1200px) {
  .column-right {
    padding-left: 0px;
  }

  .professional-card {
    border-color: #000;
  }

  .tag {
    border-width: 2px;
  }

  .action-btn {
    border: 1px solid currentColor;
  }
}
</style>